var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"layout-custom",class:{catalogo: _vm.catalogo},attrs:{"xs12":""}},[_c('h2',{staticClass:"tag-title text-xs-center",class:{catalogo: _vm.catalogo}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }